import Model from '.';
import { setUser } from '../store/auth';
import { updateAgent } from '../utils/api/user';

class Agent<Prop> extends Model {
  storeAction = setUser;
  storePath = 'auth.user';

  update = async (updates: Partial<Prop>) => {
    const { data } = await updateAgent(this.props?.id, updates);

    this.updateStore(data);

    return data;
  };
}

export default Agent;
